const initial = () => {
    $('body').on('click', '.readmore-btn', (event) => {
        let $element, $parent, $parentUp;

        $element = $(event.target);

        $parent  = $element.parent();
        $parentUp = $parent.parent();

        $parentUp.css({'max-height': 'inherit'})
        $parent.hide();
    });

    $('body').on('append', '#alert-box', (event) => {
        let $elements = $(event.target).find('.readmore-box');

        $elements.each((key, content) => {
            let $element = $(content);

            if ($element.children().height() <= $element.height()) {
                $element.css({'max-height': 'inherit'});
                $element.find('.readmore-shadow').hide();
            }
        });
    });
}

(($) => {
    var origAppend = $.fn.append;

    $.fn.append = function() {
        return origAppend.apply(this, arguments).trigger("append");
    };
})(jQuery);

export default initial;
